import { Icon } from "ol/style";
import { FuelEuModule } from "../pages/fuel-eu/fuel-eu.module";
import { ModuleNameContants } from "./moduleConstants";
import { environment } from "../../environments/environment";


const tabs = [
    { header: 'Overview', content: 'Content for Overview' },
    { header: 'Voyage Data', content: 'Content for Voyage Data' },
    { header: 'Emission accounting', content: 'Content for Emission accounting' },
    { header: 'EUA Accounting', content: 'Content for EUA Accounting' },
    { header: 'EUA Invoicing', content: 'Content for EUA Invoicing' },
    { header: 'EUA Procurement', content: 'Content for EUA Procurement' },
];
export const MainmodelConstant = [
    {
        label: '',
        items: [
            { label: 'Tracking Screen', icon: 'tracking2', routerLink: ['./pages/maptiler'], ModuleName: 'TrackingScreen' }, 

            { label: 'Voyage Optimisation', icon: 'voyage-op-m', routerLink: ['./pages/voyage-optimisation'], ModuleName: 'VoyageOptimisation' },
            { label: 'Time Charter', icon: 'time-charter-m', routerLink: ['./pages/time-charterer'], ModuleName: 'TimeCharterer' },


            { label: 'Passages', icon: 'passage-m', routerLink: ['/pages/passages/voyages/list-voyages'], ModuleName: 'Passages' },
            {
                label: 'Emissions - Compliance', icon: 'ems-m', class: 'level2-menu', ModuleName: 'EMS',
                items: [
                    { label: ' IMO DCS', routerLink: ['/pages/ems/imo-dcs'] },
                    { label: ' EU MRV', routerLink: ['/pages/ems/eu-mrv'] },
                    // UK-MRV section is intentionally commented out because it is not used at the moment.
                    // Keep it for future reference; uncomment if UK-MRV functionality is required later.
                    { label: ' UK ETS', routerLink: ['./pages/ems/uk-mrv'] },
                    { label: ' Emissions', routerLink: ['./pages/ems/emission'] },
                    { label: ' AER – CII Rating', routerLink: ['./pages/ems/aer'] },
                    { label: ' Sea Cargo Charter', routerLink: ['./pages/ems/sea-cargo-charter'] },
                    { label: ' Poseidon Principles', routerLink: ['./pages/ems/poseidon-principles'] },
                    // { label: ' EMS Analytics', routerLink: ['./pages/ems/ems-analytics'] },
                   // { label: ' Annual Vessel CII', routerLink: ['./pages/ems/annual-vessel'] },
                    { label: ' Data Verification', routerLink: ['./pages/verification'] },
                ]
            },

            {
                label: 'Emissions - ETS', icon: 'ets-m', class: 'level2-menu', ModuleName: 'ETS',
                items: [
                    // Dynamically generate items from tabs
                    ...tabs.map((tab) => ({
                        label: tab.header,
                        icon: getTabIcon(tab.header),  // Fetch corresponding icon for each tab
                        routerLink: [`./pages/ets/${tab.header.toLowerCase().replace(/ /g, '-')}`],  // Generate route dynamically
                        ModuleName: 'ETS',  // Assign the same module name
                    })),
                    // Static menu items
                    // {
                    //     label: 'Overview',
                    //     icon: 'pi pi-fw pi-chart-line',
                    //     routerLink: ['./pages/ets/overview'],
                    //     ModuleName: 'ETS'
                    // },
                    // {
                    //     label: 'Voyage Data',
                    //     icon: 'pi pi-fw pi-globe',
                    //     routerLink: ['./pages/ets/voyage-data'],
                    //     ModuleName: 'ETS'
                    // },
                    // {
                    //     label: 'Emission accounting',
                    //     icon: 'pi pi-fw pi-file',
                    //     routerLink: ['./pages/ets/emission-accounting'],
                    //     ModuleName: 'ETS'
                    // },
                    // {
                    //     label: 'EUA Accounting',
                    //     icon: 'pi pi-fw pi-calculator',
                    //     routerLink: ['./pages/ets/eua-accounting'],
                    //     ModuleName: 'ETS'
                    // },
                    // {
                    //     label: 'EUA Invoicing',
                    //     icon: 'pi pi-fw pi-dollar',
                    //     routerLink: ['./pages/ets/eua-invoicing'],
                    //     ModuleName: 'ETS'
                    // },
                    // {
                    //     label: 'EUA Procurement',
                    //     icon: 'pi pi-fw pi-shopping-cart',
                    //     routerLink: ['./pages/ets/eua-procurement'],

                    // },
                    {
                        label: 'Accounting',
                        icon: 'common-icon-m',
                        routerLink: ['./pages/ets/accounting'],
                        ModuleName: 'ETS'
                    },
                    {
                        label: 'Reports',
                        icon: 'common-icon-m',
                        routerLink: ['./pages/ets/reports'],
                        ModuleName: 'ETS'
                    }
                ]
            },
            {
                label: 'Emissions - FuelEU', icon: 'fuel-eu-m', class: 'level2-menu', ModuleName: 'FuelEU',
                items: [
                  //hiding old penalty calculator
                    //{ label: 'Penalty Calculator', icon: 'common-icon-m', routerLink: ['./pages/fuel-eu/penalty-calculator'] },
                    { label: 'Penalty Calculator', icon: 'common-icon-m', routerLink: ['./pages/fuel-eu/penalty-calculator-next'] },
                    { label: 'FuelEU', icon: 'common-icon-m', routerLink: ['./pages/fuel-eu/fuel-eu'] },
                ]

            },

            {
                label: 'Analytics', icon: 'analytics-m', class: 'level2-menu', ModuleName: 'Analytics',
                items: [
                    { label: ' Analytics KPI', icon: 'common-icon-m', routerLink: ['./pages/analytics'] },
                    { label: ' Value Capture ', icon: 'common-icon-m', routerLink: ['./pages/analytics/error-log'] },
                    //{ label: ' Payback Calculator ', routerLink: ['./pages/analytics/payback-calc']},
                    { label: ' Hull Management ', icon: 'common-icon-m', routerLink: ['./pages/analytics/hull-management-calc'] },
                    //{ label: ' Advanced Analytics - HF ', routerLink: ['./pages/analytics/advance-analytics-hf']},
                    { label: ' Advanced Analytics - LF ', icon: 'common-icon-m', routerLink: ['./pages/analytics/advance-analytics-lf'] },
                    //{ label: ' Advanced Analytics', routerLink: ['./pages/analytics/advance-analytics']},
                    // { label: ' Bunker Dashboard ', icon: 'common-icon-m', routerLink: ['./pages/analytics/bunker-dashboard'] },
                    { label: ' Speed & Consumption ', icon: 'common-icon-m', routerLink: ['./pages/analytics/speed-consumption'] },
                    //{ label: ' Bunker Buying ', routerLink: ['./pages/analytics/bunker-buying']}
                    { label: ' Pool Performance ', icon: 'common-icon-m', routerLink: ['./pages/analytics/pool-performance'] },
                   // { label: ' PowerBI Testing ', icon: 'common-icon-m', routerLink: ['./pages/analytics/powerbi-testing'] }


                ]
            },
            {
                label: 'Pulse', icon: 'pulse-m', ModuleName: 'SensorAnalytics',
                // Opens Pulse in a new tab rather than navigating — pulse.geoserves.com
                // sends X-Frame-Options: SAMEORIGIN, which blocks iframe embedding, and
                // there's nothing else to route to here. Hands our own bearer token
                // straight to Pulse via the URL; its backend verifies it directly.
                command: () => {
                    const token = localStorage.getItem('token');
                    const url = token
                        ? `${environment.pulseUrl}?token=${encodeURIComponent(token)}`
                        : environment.pulseUrl;
                    window.open(url, '_blank', 'noopener,noreferrer');
                }
            },

            // {
            //     label: 'Terms', icon: 'terms-m', class: 'level2-menu', ModuleName: 'Terms',
            //     items: [
            //         { label: ' Time Charter Terms', icon:'common-icon-m', routerLink: ['./pages/terms/passage-term/list-passage-term'] },

            //         { label: ' Voyage Performance', icon:'common-icon-m', routerLink: ['./pages/terms/voyage-term/list-voyage-term'] },
            //         // {label:'Enviro Tech-Terms',routerLink:['']},
            //         { label: ' Pool Terms', icon:'common-icon-m', routerLink: ['./pages/terms/pool-term/add-edit-pool-term'] },
            //         { label: ' TC Terms 2.0', icon:'common-icon-m', routerLink: ['./pages/terms/tc-term/tc-term-master'] },
            //     ]
            // },
            { label: 'Reports', icon: 'reports-m', routerLink: ['./pages/report/list-report'], ModuleName: 'Report' },
            { label: 'Downloads', icon: 'download-m', routerLink: ['./pages/download'], ModuleName: 'Downloads' },
           
            // Tracking Screen label name change to tracking screen old and module name also changed and commented 

          //  { label: 'Tracking Screen old', icon: 'tracking', routerLink: ['/pages/dashboard'], ModuleName: 'TrackingScreen old' },

            // { label: 'ETS', icon: 'fas fa-cube', class: 'level2-menu',ModuleName:'ETS' ,

            //     items: [
            //         { label: ' ETS',  routerLink: ['./pages/ets'] },
            //         { label: ' Accounting ', routerLink: ['./pages/ets/accounting']},
            //         { label: 'Reports', routerLink: ['./pages/ets/reports']}

            //     ]

            // },



            // {
            //     label: 'Analytics', icon: 'uil uil-analytics', class: 'level2-menu',
            //     items: [
            //         { label: ' Utilization',  routerLink: ['/pages/analytics/utilization'] },
            //         { label: ' Fuel Performance', routerLink: ['/pages/analytics/fuelperformance']},
            //         { label: ' Fuel Utilization', routerLink: ['/pages/analytics/fuelutilization']},
            //         { label:  ' Time Utilization',routerLink:['/pages/analytics/time-utilization']},
            //         { label:  ' Geo Chart',routerLink:['/pages/analytics/geo-chart']},
            //         { label:  ' Relative Fuel Efficiency',routerLink:['/pages/analytics/relative-fuel-efficiency']},
            //         { label:  ' List Analytics',routerLink:['/pages/analytics/list-analytics']},

            //     ]
            // },
            // {
            //     label: 'Settings', icon: 'uil uil-atom', class: 'level2-menu',
            //     items: [
            //         {
            //         label: 'Data Master', icon: 'uil uil-apps', class: 'level2-menu',
            //         items: [
            //             {label:'Vessel',routerLink:['pages/settings/vessel/vessel-list']},
            //             {label:'Vessel Class',routerLink:['pages/settings/vessel-class/vesselclass-list']},
            //             {label:'VesselPoolType',routerLink:['/pages/settings/vessels-pooltype/vesselpooltype-list']},
            //             {label:'Consumption Category',routerLink:['/pages/settings/consumption-categories/consumption-list']},
            //             {label: ' Fuel',  routerLink: ['/pages/settings/fuel/fuellist'] },
            //             {label:'Vessel Group',routerLink:['pages/settings/vessel-group/vesselgroup-list']},
            //             { label: ' Fuel Category',  routerLink: ['/pages/settings/fuel-category/list'] },
            //             {label:'Units Of Measure And Threshold',routerLink:['/pages/settings/units-of-measure-and-threshold/units-of-measure-and-threshold']},
            //             {label:'Event',routerLink:['/pages/settings/event/event-list']},
            //             {
            //                 label: 'Custom-Kpi', icon: 'pi pi-list', class: 'level2-menu',
            //                 items: [
            //                     { label: ' Emission-Kpi',  routerLink: ['/pages/settings/custom-kpi/emission-kpi'] },
            //                     { label: ' Fuel-Kpi', routerLink: ['/pages/settings/custom-kpi/list-fuel-kpi']},
            //                     { label: ' Position-Kpi', routerLink: ['/pages/settings/custom-kpi/list-position-kpi']},

            //                 ]
            //             },
            //             {label:'Custom-Vessel',routerLink:['./pages/settings/customvessel/custom-vessellist']},

            //             {label:'NOX-PM-Factors',routerLink:['pages/settings/nox-pm-factor/nox-pm-factor-list']},
            //             {label:'Port',routerLink:['./pages/settings/port/port-list']},








            //         ]
            //     },
            //     {
            //         label: 'AlertSettings', icon: 'pi pi-exclamation-triangle', class: 'level2-menu',
            //         items: [
            //             { label: ' Standard Alerts',  routerLink: ['pages/settings/standard-alerts/standard-alert-list'] },

            //         ]
            //     },
            //     { label: 'About', icon: 'pi pi-exclamation-circle', routerLink: ['/pages/settings/about'] },
            //     ]
            // },
            // {
            //     label: 'User Settings', icon: 'pi pi-user', class: 'level2-menu',
            //     items: [
            //         { label: ' Users', icon: 'pi pi-users', routerLink: ['./pages/userSetting/user/user-list'] },
            //         { label: ' Role',icon: 'pi pi-user-plus', routerLink: ['./pages/userSetting/role/list-role'] },
            //         { label: ' Role Policy Mapping',icon: 'pi pi-credit-card', routerLink: ['/pages/userSetting/authorization/authorization']},


            //     ]
            // },




            // { label: 'form', icon: 'uil uil-location-arrow', routerLink: ['/pages/form-designer'] },

            // { label: 'Forms', icon: 'uil uil-notes', routerLink: ['#'] },


            // { label: 'Position KPIs', icon: 'uil uil-atom', routerLink: ['#'] },
            // { label: 'Fuel KPIs', icon: 'uil uil-pump', routerLink: ['#'] },
            // { label: 'Emission KPIs', icon: 'uil uil-flask', routerLink: ['#'] },
            // { label: 'User Settings', icon: 'uil uil-sliders-v-alt', routerLink: ['#'] },
            // {
            //     label: 'auth', icon: 'uil uil-file-info-alt', class: 'level2-menu',
            //     items: [
            //         { label: 'login', routerLink: ['/auth/login']},

            //     ]
            // },
        ]

    },
];
function getTabIcon(tabHeader: string): string {
    switch (tabHeader) {
        case 'Overview':
            return 'common-icon-m';
        case 'Voyage Data':
            return 'common-icon-m';
        case 'Emission accounting':
            return 'common-icon-m';
        case 'EUA Accounting':
            return 'common-icon-m';
        case 'EUA Invoicing':
            return 'common-icon-m';
        case 'EUA Procurement':
            return 'common-icon-m';
        default:
            return 'common-icon-m';  // Default icon
    }
}

// const menuItems = tabs.map((tab) => ({
//     label: tab.header,
//     icon: getTabIcon(tab.header),
//     routerLink: getRouterLink(tab.header),
// }));


function getRouterLink(tabHeader: string): string {
    switch (tabHeader) {
        case 'Overview':
            return '/pages/ets/overview';
        case 'Voyage Data':
            return '/pages/ets/voyage-data';
        case 'Emission accounting':
            return '/pages/ets/emission-accounting';
        case 'EUA Accounting':
            return '/pages/ets/eua-accounting';
        case 'EUA Invoicing':
            return '/pages/ets/eua-invoicing';
        case 'EUA Procurement':
            return '/pages/ets/eua-procurement';
        default:
            return '/pages/ets/reports';  // Default route
    }
}
